import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import Images from "../../constants/Images";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <>
      <section className="info_section">
        <div className="container">
          <h4>{t("contact")}</h4>
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="info_items">
                <div className="row">
                  <div className="col-md-4">
                    <a
                      href="https://wa.me/681480507"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Contactez-nous sur WhatsApp"
                    >
                      <div className="item">
                        <div className="img-box">
                          <i className="fab fa-whatsapp" aria-hidden="true"></i>
                        </div>
                        <p style={{ color: "black" }}>Contact WhatsApp</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-4">
                    <a
                      href="tel:+237681480507"
                      aria-label="Appeler le support au +237 650039895"
                    >
                      <div className="item">
                        <div className="img-box">
                          <i className="fa fa-phone" aria-hidden="true"></i>
                        </div>
                        <p style={{ color: "black" }}>+237681480507</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-4">
                    <a
                      href="mailto:helpdesk@credixcm.com"
                      aria-label="Envoyer un e-mail à helpdesk@credixcm.com"
                    >
                      <div className="item">
                        <div className="img-box">
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        </div>
                        <p style={{ color: "black" }}>
                          helpdesk@credixcm.com
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer_section">
        <div className="container">
          <section className="social-media">
            <div className="social-media-wrap">
              <div className="footer-logo">
                <Link to="/" className="social-logo">
                  <img
                    className="no-hover-effect mb-1"
                    src={Images.digital}
                    height={120}
                    width={120}
                    alt="TechCare237 Logo"
                  />
                </Link>
              </div>
              <small className="website-rights mt-3">TechCare © {year}</small>
              <Link to="/tec">
                <small className="website-rights">
                  {t("Conditions Générales")}
                </small>
              </Link>
              <div className="social-icons">
                <a
                  href="https://www.sanlam.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visiter le site de Sanlam"
                  className="social-icon-link"
                >
                  <div className="logo-frame">
                    <img
                      src={Images.SanlamLogo}
                      alt="Sanlam Logo"
                      className="no-hover-effect"
                    />
                  </div>
                </a>
                <a
                  href="https://www.credixcm.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visiter le site de Credix"
                  className="social-icon-link"
                >
                  <div className="logo-frame">
                    <img
                      src={Images.CredixLogo}
                      alt="Credix Logo"
                      className="no-hover-effect"
                    />
                  </div>
                </a>
              </div>
            </div>
          </section>
        </div>
      </footer>
    </>
  );
}

export default Footer;
